export const getColumns = (intl) => ({
  name: {
    title: intl.formatMessage({
      id: 'pages.quality.normative.statisticalControl.list.column.name',
    }),
    dataIndex: 'name',
    key: 'name',
    width: '80px',
  },
  supplier_id: {
    title: intl.formatMessage({
      id: 'pages.quality.normative.statisticalControl.list.column.supplier_id',
    }),
    dataIndex: 'supplier_id',
    key: 'supplier_id',
    align: 'center',
  },
  plant: {
    title: intl.formatMessage({
      id: 'pages.quality.normative.statisticalControl.list.column.plant',
    }),
    dataIndex: 'plant',
    key: 'plant',
    align: 'center',
  },
  recipe: {
    title: intl.formatMessage({
      id: 'pages.quality.normative.statisticalControl.list.column.recipe',
    }),
    dataIndex: 'recipe',
    key: 'recipe',
    align: 'center',
    width: '200px',
  },
  concrete_quality: {
    title: intl.formatMessage({
      id: 'pages.quality.normative.statisticalControl.list.column.concreteQuality',
    }),
    dataIndex: 'concrete_quality',
    key: 'concrete_quality',
    align: 'center',
    width: '80px',
  },
  certifiedDispersion: {
    title: intl.formatMessage({
      id: 'pages.quality.normative.statisticalControl.list.column.certifiedDispersion',
    }),
    dataIndex: 'certifiedDispersion',
    key: 'certifiedDispersion',
    align: 'center',
    width: '80px',
  },
});
